const state = () => ({
	mqttAlarmList : [],
	messageArrivedTime : ""
});

const getters = {
	getMqttAlarmList: state => state.mqttAlarmList,
	getMessageArrivedTime: state => state.messageArrivedTime,
};

const actions = {

	setMqttAlarmList({ commit }, data) {
    commit('SET_MQTT_ALARM_LIST' , data);
	},
	setMessageArrivedTime({ commit }, data) {
		commit('SET_MESSAGE_ARRIVED_TIME' , data);
	},
};

const mutations = {
	SET_MQTT_ALARM_LIST(state, payload) {
		state.mqttAlarmList = payload;
	},
	SET_MESSAGE_ARRIVED_TIME(state, payload) {
		state.messageArrivedTime = payload;
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
